import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e?.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { password });
      localStorage.setItem("gh_admin_token", data.token);
      // Also store in sessionStorage as a defense-in-depth measure;
      // admin sessions are short-lived per game.
      sessionStorage.setItem("gh_admin_token", data.token);
      toast.success("Welcome, Coach");
      navigate("/admin/dashboard");
    } catch {
      toast.error("Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white text-slate-900 flex items-center justify-center px-6 bg-silver-stripes">
      <form
        onSubmit={handleLogin}
        className="w-full max-w-sm border-2 border-slate-900 bg-white p-8"
      >
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center bg-[#1d4ed8] text-white border border-slate-900">
            <Lock className="h-5 w-5" strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-heading text-2xl tracking-wider">STAFF LOGIN</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">
              Cowboys Concession Ops
            </div>
          </div>
        </div>

        <label className="text-[10px] uppercase tracking-[0.2em] text-slate-500">
          Admin Password
        </label>
        <input
          data-testid="admin-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
          className="mt-1 w-full bg-white border border-slate-300 px-3 py-3 text-slate-900 focus:border-[#1d4ed8] focus:outline-none focus:ring-1 focus:ring-[#1d4ed8]"
          placeholder="••••••••"
        />

        <button
          data-testid="admin-login-btn"
          type="submit"
          disabled={loading || !password}
          className="mt-6 flex w-full items-center justify-center gap-2 bg-[#1d4ed8] py-3 font-heading text-lg tracking-wider text-white hover:bg-[#1e40af] disabled:opacity-50 border border-slate-900"
        >
          {loading ? "..." : "ENTER DASHBOARD"}
          <ArrowRight className="h-5 w-5" strokeWidth={2.5} />
        </button>

        <button
          type="button"
          onClick={() => navigate("/")}
          className="mt-4 w-full text-[10px] uppercase tracking-[0.2em] text-slate-500 hover:text-slate-900"
        >
          ← Back to ordering
        </button>
      </form>
    </div>
  );
}
